var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7763B784-6F8E-479A-8128-4DBA52D1BC67") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#023B93",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-1019.000000, -456.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1019.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "##023B93",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(11.514731, 11.514731)",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.81860196,
    y1: 2.83820981,
    x2: 14.1519353,
    y2: 14.1323275,
    id: "Line-3",
    transform: "translate(8.485269, 8.485269) rotate(45.099299) translate(-8.485269, -8.485269) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.81860196,
    y1: 2.83820981,
    x2: 14.1519353,
    y2: 14.1323275,
    id: "Line-3",
    transform: "translate(8.485269, 8.485269) scale(-1, 1) rotate(-44.900701) translate(-8.485269, -8.485269) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPlusIcon);
export default __webpack_public_path__ + "static/media/filled-plus-icon.dd4042ac16261389132088c2188e1286.svg";
export { ForwardRef as ReactComponent };